import React,{useState,useEffect,useContext} from 'react';
import CartContext from './Contexts/CartContext';
import TitoloPagine from './TitoloPagine'
import OrderListItem from './details/OrderListItem';
import { SpinnerInsidePage } from '../MainComponents/Spinner';

function OrderList(props) {
    // const contextAuth = useContext(AuthContext)
    const statusFilter =['shipped','completed','refunded','confirmed']
    const contextCart = useContext(CartContext)
    const [orders, setOrders] = useState(undefined)

    useEffect(() => {
        setOrders(contextCart.CartState.orders)
    }, contextCart.CartState.orders)

    return (
        <>
            <div>
                {!orders ? <SpinnerInsidePage />:
                <>
                    <div className="row">
                        <div className="col-10"> 
                            <TitoloPagine title={"I MIEI ORDINI"}></TitoloPagine>
                            <div className="row" style={{textAlign:"left"}}>
                                <div className="col-4 order-table-head">DATA</div>
                                <div className="col-4 order-table-head">TOTALE</div>
                                <div className="col-4 order-table-head">STATO</div>
                            </div>
                        </div>
                    </div>

                    {orders.filter((order)=>{
                        return !statusFilter.includes(order.status)
                    }).map((order,i)=>{
                        return(
                            <OrderListItem order = {order}></OrderListItem>
                        )
                    })}

                    <div className="row" style={{marginTop:"20px"}}>
                        <div className="col-10"> 
                            <TitoloPagine title={"STORICO ORDINI"}></TitoloPagine>
                            <div className="row" style={{textAlign:"left"}}>
                                <div className="col-4 order-table-head">DATA</div>
                                <div className="col-4 order-table-head">TOTALE</div>
                                <div className="col-4 order-table-head">STATO</div>
                            </div>
                        </div>
                    </div>
                    {orders.filter((order)=>{
                        return statusFilter.includes(order.status)
                    }).map((order,i)=>{
                        return(
                            <OrderListItem key={i} order = {order}></OrderListItem>
                        )
                    })}
                </>
                }
            </div>
        </>
        
    );
}

export default OrderList;